/*!
 * a&k Briefkasten — Mehrere Warenkörbe (Saved Carts)
 * Eigenentwicklung, abhängigkeitsfrei. Speichert Warenkorb-Snapshots im
 * localStorage des Browsers und stellt sie über die Shopify Cart-AJAX-API
 * wieder her. Konfigurator-Auswahl bleibt über Line-Item-Properties erhalten.
 *
 * Einbau: 1x  {% render 'saved-carts' %}  vor </body> in layout/theme.liquid
 */
(function () {
  'use strict';

  var CFG = window.AK_SAVED_CARTS_CONFIG || {};
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var STORAGE_KEY = CFG.storageKey || 'ak_saved_carts_v1';
  var MAX_CARTS = CFG.maxCarts || 20;
  var POSITION = CFG.position || 'bottom-left';
  var REDIRECT_ON_LOAD = CFG.redirectToCartOnLoad !== false;

  var T = Object.assign({
    button: 'Warenkörbe',
    title: 'Gespeicherte Warenkörbe',
    saveCurrent: 'Aktuellen Warenkorb speichern',
    namePlaceholder: 'Name (optional)',
    save: 'Speichern',
    empty: 'Noch keine gespeicherten Warenkörbe.',
    load: 'Laden',
    append: 'Hinzufügen',
    rename: 'Umbenennen',
    remove: 'Löschen',
    close: 'Schließen',
    items: 'Artikel',
    confirmReplace: 'Aktuellen Warenkorb durch diesen ersetzen?',
    confirmRemove: 'Diesen gespeicherten Warenkorb wirklich löschen?',
    saved: 'Warenkorb gespeichert.',
    cartEmpty: 'Dein Warenkorb ist leer – es gibt nichts zu speichern.',
    loaded: 'Warenkorb geladen.',
    someFailed: 'Einige Artikel sind nicht mehr verfügbar und wurden übersprungen.',
    renamePrompt: 'Neuer Name:',
    defaultName: 'Warenkorb'
  }, CFG.labels || {});

  // ---- Helpers ------------------------------------------------------------
  function fmtMoney(cents) {
    try {
      return new Intl.NumberFormat('de-DE', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' }).format((cents || 0) / 100);
    } catch (e) { return ((cents || 0) / 100).toFixed(2) + ' €'; }
  }
  function uid() { return 'c' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function load() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var data = raw ? JSON.parse(raw) : null;
      if (data && Array.isArray(data.carts)) return data;
    } catch (e) {}
    return { version: 1, carts: [] };
  }
  function persist(data) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(data)); }
    catch (e) { toast('Speicher voll – ältere Warenkörbe löschen.'); }
  }

  function getCart() {
    return fetch(ROOT + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }
  function clearCart() {
    return fetch(ROOT + 'cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' } });
  }
  // Artikel einzeln hinzufügen, damit nicht verfügbare Varianten den Rest nicht blockieren.
  function addItem(line) {
    var body = { id: line.id, quantity: line.quantity };
    if (line.properties && Object.keys(line.properties).length) body.properties = line.properties;
    if (line.selling_plan) body.selling_plan = line.selling_plan;
    return fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.ok ? true : false; }).catch(function () { return false; });
  }

  function snapshot(cart) {
    return (cart.items || []).map(function (it) {
      return {
        id: it.variant_id || it.id,
        quantity: it.quantity,
        properties: it.properties || null,
        selling_plan: (it.selling_plan_allocation && it.selling_plan_allocation.selling_plan && it.selling_plan_allocation.selling_plan.id) || null,
        title: it.product_title || it.title,
        variant_title: it.variant_title || '',
        price: it.price,
        image: it.image
      };
    });
  }

  // ---- Aktionen -----------------------------------------------------------
  function saveCurrent(name) {
    return getCart().then(function (cart) {
      if (!cart.items || !cart.items.length) { toast(T.cartEmpty); return false; }
      var data = load();
      var items = snapshot(cart);
      data.carts.unshift({
        id: uid(),
        name: (name && name.trim()) || (T.defaultName + ' ' + (data.carts.length + 1)),
        createdAt: Date.now(),
        updatedAt: Date.now(),
        itemCount: cart.item_count,
        total: cart.total_price,
        items: items
      });
      if (data.carts.length > MAX_CARTS) data.carts = data.carts.slice(0, MAX_CARTS);
      persist(data);
      toast(T.saved);
      render();
      return true;
    });
  }

  function applyCart(saved, replace) {
    var chain = replace ? clearCart() : Promise.resolve();
    var failed = 0;
    return chain.then(function () {
      // sequenziell, um Reihenfolge & Properties sicher zu übertragen
      return saved.items.reduce(function (p, line) {
        return p.then(function () { return addItem(line).then(function (ok) { if (!ok) failed++; }); });
      }, Promise.resolve());
    }).then(function () {
      if (failed) toast(T.someFailed);
      else toast(T.loaded);
      if (REDIRECT_ON_LOAD) { window.location.assign(ROOT + 'cart'); }
      else { document.dispatchEvent(new CustomEvent('ak:cart-updated')); window.location.reload(); }
    });
  }

  function removeCart(id) {
    var data = load();
    data.carts = data.carts.filter(function (c) { return c.id !== id; });
    persist(data); render();
  }
  function renameCart(id, name) {
    var data = load();
    data.carts.forEach(function (c) { if (c.id === id) { c.name = name; c.updatedAt = Date.now(); } });
    persist(data); render();
  }

  // ---- UI -----------------------------------------------------------------
  var panel, listEl, nameInput, toastEl;

  function buildUI() {
    var style = document.createElement('style');
    style.textContent = [
      '.aksc-fab{position:fixed;z-index:9998;border:0;border-radius:999px;padding:12px 18px;font:600 14px/1 system-ui,sans-serif;cursor:pointer;background:#1a1a1a;color:#fff;box-shadow:0 4px 16px rgba(0,0,0,.2);display:inline-flex;gap:8px;align-items:center}',
      '.aksc-fab:hover{opacity:.92}',
      '.aksc-pos-bottom-left{left:18px;bottom:18px}.aksc-pos-bottom-right{right:18px;bottom:18px}',
      '.aksc-overlay{position:fixed;inset:0;z-index:9999;background:rgba(0,0,0,.45);display:none;align-items:flex-end;justify-content:center}',
      '.aksc-overlay.open{display:flex}',
      '.aksc-modal{background:#fff;width:100%;max-width:560px;max-height:82vh;border-radius:16px 16px 0 0;display:flex;flex-direction:column;overflow:hidden;font:14px/1.4 system-ui,sans-serif;color:#1a1a1a}',
      '@media(min-width:600px){.aksc-overlay{align-items:center}.aksc-modal{border-radius:16px}}',
      '.aksc-head{display:flex;align-items:center;justify-content:space-between;padding:16px 18px;border-bottom:1px solid #eee}',
      '.aksc-head h2{margin:0;font-size:16px}',
      '.aksc-x{border:0;background:none;font-size:22px;line-height:1;cursor:pointer;color:#666}',
      '.aksc-save{display:flex;gap:8px;padding:14px 18px;border-bottom:1px solid #eee}',
      '.aksc-save input{flex:1;padding:10px 12px;border:1px solid #ccc;border-radius:10px;font:inherit}',
      '.aksc-btn{border:0;border-radius:10px;padding:10px 14px;font:600 13px/1 inherit;cursor:pointer;background:#1a1a1a;color:#fff}',
      '.aksc-btn.sec{background:#f1f1f1;color:#1a1a1a}',
      '.aksc-btn.danger{background:#fbeaea;color:#b3261e}',
      '.aksc-list{overflow:auto;padding:8px 18px 18px}',
      '.aksc-empty{color:#777;padding:24px 0;text-align:center}',
      '.aksc-item{border:1px solid #eee;border-radius:12px;padding:12px;margin-top:12px}',
      '.aksc-item h3{margin:0 0 2px;font-size:14px}',
      '.aksc-meta{color:#777;font-size:12px;margin-bottom:8px}',
      '.aksc-thumbs{display:flex;gap:6px;margin-bottom:10px;flex-wrap:wrap}',
      '.aksc-thumbs img{width:34px;height:34px;object-fit:cover;border-radius:6px;border:1px solid #eee}',
      '.aksc-actions{display:flex;gap:8px;flex-wrap:wrap}',
      '.aksc-toast{position:fixed;left:50%;bottom:84px;transform:translateX(-50%);z-index:10000;background:#1a1a1a;color:#fff;padding:10px 16px;border-radius:999px;font:13px system-ui;opacity:0;transition:opacity .2s;pointer-events:none}',
      '.aksc-toast.show{opacity:1}'
    ].join('');
    document.head.appendChild(style);

    var fab = document.createElement('button');
    fab.className = 'aksc-fab aksc-pos-' + POSITION;
    fab.type = 'button';
    fab.innerHTML = '<span aria-hidden="true">🛒</span><span>' + esc(T.button) + '</span>';
    fab.addEventListener('click', open);
    document.body.appendChild(fab);

    var overlay = document.createElement('div');
    overlay.className = 'aksc-overlay';
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    overlay.innerHTML =
      '<div class="aksc-modal" role="dialog" aria-modal="true" aria-label="' + esc(T.title) + '">' +
        '<div class="aksc-head"><h2>' + esc(T.title) + '</h2><button class="aksc-x" aria-label="' + esc(T.close) + '">&times;</button></div>' +
        '<div class="aksc-save"><input type="text" placeholder="' + esc(T.namePlaceholder) + '"><button class="aksc-btn" data-save>' + esc(T.saveCurrent) + '</button></div>' +
        '<div class="aksc-list"></div>' +
      '</div>';
    document.body.appendChild(overlay);
    panel = overlay;
    listEl = overlay.querySelector('.aksc-list');
    nameInput = overlay.querySelector('.aksc-save input');
    overlay.querySelector('.aksc-x').addEventListener('click', close);
    overlay.querySelector('[data-save]').addEventListener('click', function () { saveCurrent(nameInput.value).then(function (ok) { if (ok) nameInput.value = ''; }); });

    toastEl = document.createElement('div');
    toastEl.className = 'aksc-toast';
    document.body.appendChild(toastEl);

    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  function render() {
    if (!listEl) return;
    var data = load();
    if (!data.carts.length) { listEl.innerHTML = '<div class="aksc-empty">' + esc(T.empty) + '</div>'; return; }
    listEl.innerHTML = data.carts.map(function (c) {
      var thumbs = (c.items || []).slice(0, 6).map(function (i) {
        return i.image ? '<img src="' + esc(i.image) + '" alt="" loading="lazy">' : '';
      }).join('');
      return '<div class="aksc-item" data-id="' + c.id + '">' +
        '<h3>' + esc(c.name) + '</h3>' +
        '<div class="aksc-meta">' + (c.itemCount || 0) + ' ' + esc(T.items) + ' · ' + fmtMoney(c.total) + '</div>' +
        (thumbs ? '<div class="aksc-thumbs">' + thumbs + '</div>' : '') +
        '<div class="aksc-actions">' +
          '<button class="aksc-btn" data-act="load">' + esc(T.load) + '</button>' +
          '<button class="aksc-btn sec" data-act="append">' + esc(T.append) + '</button>' +
          '<button class="aksc-btn sec" data-act="rename">' + esc(T.rename) + '</button>' +
          '<button class="aksc-btn danger" data-act="remove">' + esc(T.remove) + '</button>' +
        '</div>' +
      '</div>';
    }).join('');

    Array.prototype.forEach.call(listEl.querySelectorAll('.aksc-item'), function (el) {
      var id = el.getAttribute('data-id');
      var data2 = load();
      var saved = data2.carts.filter(function (c) { return c.id === id; })[0];
      el.querySelector('[data-act="load"]').addEventListener('click', function () { if (confirm(T.confirmReplace)) applyCart(saved, true); });
      el.querySelector('[data-act="append"]').addEventListener('click', function () { applyCart(saved, false); });
      el.querySelector('[data-act="rename"]').addEventListener('click', function () { var n = prompt(T.renamePrompt, saved.name); if (n != null && n.trim()) renameCart(id, n.trim()); });
      el.querySelector('[data-act="remove"]').addEventListener('click', function () { if (confirm(T.confirmRemove)) removeCart(id); });
    });
  }

  function open() { render(); panel.classList.add('open'); }
  function close() { panel.classList.remove('open'); }

  var toastTimer;
  function toast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg; toastEl.classList.add('show');
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { toastEl.classList.remove('show'); }, 2600);
  }

  // ---- Init ---------------------------------------------------------------
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', buildUI);
  else buildUI();

  // öffentliche API (optional für eigene Buttons im Theme)
  window.AKSavedCarts = { open: open, close: close, save: saveCurrent, list: function () { return load().carts; } };
})();
